module.exports = __webpack_public_path__ + "media/reskin-images/icon--support-fe66d85e.svg";